module.exports = __webpack_public_path__ + "icomoon.397ff01791418ecf7ae1.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/node_modules/ngx-select-dropdown/dist/assets/fonts/icomoon.eot?eh7l1v
// module id = ../../../../ngx-select-dropdown/dist/assets/fonts/icomoon.eot?eh7l1v
// module chunks = styles